<template>
  <div class="login-container">
    <el-form ref="form" :model="registForm" label-width="80px" class="login-form">
      <div class="title-container">
        <span>{{ title }}</span>
      </div>
      <el-form-item label="电子邮箱">
        <el-input v-model="registForm.userName"></el-input>
      </el-form-item>
      <el-form-item label="密码">
        <el-input v-model="registForm.password" type="password"></el-input>
      </el-form-item>
      <el-form-item label="确认密码">
        <el-input v-model="registForm.passwordAgain" type="password"></el-input>
      </el-form-item>
      <div>
        <el-button type="primary" @click="regist" style="width: 100%;" size="normal" :loading="loading">注册</el-button>
      </div>
      <div style="text-align: right;">
        <el-button type="text" @click="goLogin">返回登陆页面</el-button>
      </div>
      <div class="footer">
        <span v-html="footer"></span>
      </div>
    </el-form>
  </div>
</template>

<script>
import { register } from '@/util/request.js'

export default {
  name: 'Login',
  data() {
    return {
      title: '账号注册',
      msg: 'jayhuang',
      loading: false,
      footer: '电子邮箱即为您的登陆账号，请牢记，如遗忘密码请联系管理员进行重置',
      registForm: {
        userName: '',
        password: '',
        passwordAgain: '',
      }
    }
  },
  methods: {
    regist() {
      if (this.registForm.password !== this.registForm.passwordAgain) {
        this.$message.error('两次输入的密码不一致')
        return
      }
      if (this.registForm.password.length < 8) {
        this.$message.error('密码长度必须大于8位')
        return
      }
      this.loading = true
      register(this.registForm).then(data => {
        this.loading = false
        if (data.resultCode === 1) {
          this.$confirm('注册成功,是否转到登陆', '确定', { type: 'success' }).then(() => {
            this.goLogin()
          })

        } else
          this.$message.error(data.info)
      }).catch(e => {
        this.loading = false
      })
    },
    goLogin() {
      this.$router.push('/login')
    }
  }
}
</script>
<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.login-container {
  min-height: 100%;
  width: 100%;
  background-color: #2d3a4b;
  overflow: hidden;
}

.login-form {
  position: relative;
  width: 500px;
  max-width: 100%;
  padding: 100px 35px 0;
  margin: 0 auto;
  overflow: hidden;

  .el-form-item {
    border: 1px solid hsla(0, 0%, 100%, .1);
    background: rgba(0, 0, 0, .1);
    border-radius: 5px;
    color: #454545;
  }

  input {
    background: transparent;
    border: none;
    color: white;
  }
}

.footer {
  color: #bbbaba;
  padding-top: 10px;
  font-size: 12px;

}

.title-container {
  color: white;
  padding-bottom: 10px;
  line-height: 2em;
  font-size: 1.5em;
}
</style>



// WEBPACK FOOTER //
// src/components/Regist.vue